import React from 'react';
import './MetricsBanner.css';

const MetricsBanner = () => {
  return (
    <div className="metrics-banner">
      <div className="metrics-container">
        <div className="metrics-columns">

          <div className="metrics-column">
            <div className="metric-number">30+</div>
            <div className="metric-text">Years of expertise</div>
          </div>

          <div className="metrics-column">
            <div className="metric-number">3,000+</div>
            <div className="metric-text">Products</div>
          </div>

          <div className="metrics-column">
            <div className="metric-number">10+</div>
            <div className="metric-text">Countries</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricsBanner;
